(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["formatees-catalog-hub"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-formatees-catalog]');
    roots.forEach((root) => {
      const buttons = root.querySelectorAll('[data-filter]');
      const cards = root.querySelectorAll('[data-category]');
      const applyFilter = (filter) => {
        buttons.forEach((button) => {
          const active = button.dataset.filter === filter;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', String(active));
        });
        cards.forEach((card) => {
          card.hidden = filter === 'lavados' ? card.dataset.washEligible !== 'true' : filter !== 'todos' && card.dataset.category !== filter;
        });
      };
      buttons.forEach((button) => button.addEventListener('click', () => applyFilter(button.dataset.filter)));
      const requested = new URLSearchParams(window.location.search).get('categoria');
      if (requested && (requested === 'lavados' || ['todos','playeras','polos','hoodies'].includes(requested))) {
        applyFilter(requested);
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["formatees-configurator-studio"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = studio => {
      if (!studio || studio.dataset.ready) return;
      studio.dataset.ready = 'true';
      const editCopy=JSON.parse(studio.querySelector('[data-cart-edit-copy]').textContent);
      const editToken=new URLSearchParams(location.search).get('editar-carrito');
      let editSource=null,editRestoreFailed=false,variantLoad=Promise.resolve();
      if(editToken){try{editSource=JSON.parse(sessionStorage.getItem('fm-cart-edit:'+editToken));if(editSource?.version!==1||Date.now()-editSource.created>86400000||!editSource.items?.length)throw Error();}catch{editRestoreFailed=true;}}
      const editIdentity=item=>JSON.stringify([Number(item.variant_id||item.id),Object.entries(item.properties||{}).sort(([a],[b])=>a.localeCompare(b)),item.selling_plan_allocation?.selling_plan?.id||null]);
      const editOriginals=cart=>cart.items.filter(i=>editSource?.items.some(old=>editIdentity(old)===editIdentity(i)));
      const verifyOriginals=cart=>{if(!editSource)return;const originals=editOriginals(cart);if(originals.length!==editSource.items.length||editSource.items.some(old=>!originals.some(i=>editIdentity(i)===editIdentity(old)&&i.quantity===old.quantity)))throw Error(editCopy.edit_changed);if(cart.currency!==editSource.currency)throw Error(editCopy.edit_currency);};
      const inline = studio.dataset.inline === 'true';
      if (!inline) {
        document.documentElement.classList.add('fm-configurator-active');
        document.body.classList.add('fm-configurator-active');
      }
      const dialog = studio.closest('[data-fm-studio-dialog]');
      const q = selector => studio.querySelector(selector);
      const qa = selector => [...studio.querySelectorAll(selector)];
      const copy = JSON.parse(q('[data-copy]').textContent);
      const washCopy=JSON.parse(q('[data-wash-copy]').textContent);Object.assign(copy,washCopy);
      const openCopy=JSON.parse(q('[data-open-copy]').textContent);
      const blanks = qa('[data-blank]');
      let openCartQuantity=0;const openProductIds=new Set(blanks.filter(b=>b.dataset.label==='open').map(b=>Number(b.dataset.productId)));
      const pricingQuantity=()=>active?.dataset.label==='open'?value()+openCartQuantity:value();
      const panel = q('[data-panel]');
      q('[data-mobile-preview]').addEventListener('click',()=>{
        const preview=q('.fm-studio__roster');
        preview.scrollIntoView({block:'start',behavior:'instant'});
        q('[data-mobile-controls]').focus({preventScroll:true});
      });
      q('[data-mobile-controls]').addEventListener('click',()=>{
        panel.scrollIntoView({block:'start',behavior:'instant'});
        q('[data-panel-title]').setAttribute('tabindex','-1');
        q('[data-panel-title]').focus({preventScroll:true});
      });
      const title = q('[data-panel-title]');
      const panelStep = q('[data-panel-step]');
      const progress = q('[data-progress]');
      const target = q('[data-options-target]');
      const selection = q('[data-selection]');
      const matrix = q('[data-size-matrix]');
      const total = q('[data-quantity-total]');
      let variants = [];
      let sizeIndex = 1;
      const quantities = new Map();
      const minimumHint = q('[data-minimum]');
      const error = q('[data-error]');
      const next = q('[data-continue]');
      const nextText = q('[data-continue-text]');
      const washGallery = q('[data-wash-gallery]');
      const washSelection = q('[data-wash-selection]');
      const washNext = q('[data-wash-continue]');
      const emptySelection = selection.textContent;
      let active;
      let option;
      let wash;
      const originalImages = new Map(blanks.map(blank => {
        const image = blank.querySelector('.fm-studio__model-image');
        return [blank, { src: image.getAttribute('src'), srcset: image.getAttribute('srcset'), alt: image.getAttribute('alt') }];
      }));
      const restoreImage = blank => {
        const image = blank.querySelector('.fm-studio__model-image');
        const original = originalImages.get(blank);
        image.classList.remove('is-product');
        image.hidden = false;
        image.onload = image.onerror = null;
        image.src = original.src;
        image.alt = original.alt;
        if (original.srcset) image.setAttribute('srcset', original.srcset);
        else image.removeAttribute('srcset');
      };
      let currentView = 'front';
      let avatarCatalog = {};
      let avatarCatalogReady = false;
      let avatarTicket = 0;
      const avatarKey = () => wash ? wash.finish + ':' + wash.index : option && option.dataset.handle !== 'lavados-especiales' ? 'base:' + option.dataset.handle : 'default';
      const avatarEntry = () => avatarCatalog?.[active?.dataset.code]?.[avatarKey()];
      const renderAvatar = () => {
        if (!active) return;
        const ticket = ++avatarTicket;
        const data = avatarEntry();
        const image = active.querySelector('.fm-studio__model-image');
        const source = data?.[currentView];
        const url = source === 'original' ? originalImages.get(active).src : source;
        const label = wash ? (copy[wash.finish] || wash.finish) + ' · ' + wash.color : option?.dataset.name || '';
        const status = q('[data-avatar-status]');
        image.onload = image.onerror = null;
        image.removeAttribute('srcset');
        image.classList.remove('is-product');
        q('[data-view="back"]').disabled = !data?.back;
        q('[data-area="back"]').disabled = !data?.back;
        qa('[data-view]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.view === currentView)));
        if (!url) {
          image.hidden = Boolean(option || wash);
          status.textContent = avatarCatalogReady ? copy.avatar_pending : copy.avatar_loading;
          return;
        }
        image.hidden = false;
        image.alt = active.dataset.title + ' · ' + label + ' · ' + (currentView === 'back' ? copy.back_view : copy.front_view);
        status.textContent = copy.avatar_loading;
        image.onload = () => {
          if (ticket !== avatarTicket) return;
          status.textContent = '';
          renderArtwork();
        };
        image.onerror = () => {
          if (ticket !== avatarTicket) return;
          image.hidden = true;
          status.textContent = copy.avatar_error;
        };
        image.src = url;
        if (image.complete && image.naturalWidth > 0) {
          status.textContent = '';
          requestAnimationFrame(renderArtwork);
        }
      };
      const artStates = new Map();
      let artArea = 'front';
      let artTicket = 0;
      const artFile = q('[data-art-file]');
      const artStatus = q('[data-art-status]');
      const artControls = q('[data-art-controls]');
      const artPlanes = new Map();
      const artKey = () => active?.dataset.code + ':' + artArea;
      const artState = () => artStates.get(artKey());
      const hideArtwork = () => artPlanes.forEach(plane => { plane.hidden = true; });
      const region = (area = artArea) => area === 'neck' ? {x:.25,y:.36,w:.5,h:.32} : area === 'front' ? (active?.dataset.code === '44560' ? {x:.37,y:.23,w:.26,h:.12} : active?.dataset.code === '13040' ? {x:.38,y:.24,w:.24,h:.16} : {x:.36,y:.20,w:.28,h:.24}) : active?.dataset.code === '44560' ? {x:.35,y:.28,w:.30,h:.19} : {x:.35,y:.20,w:.30,h:.25};
      const planeFor = () => {
        const host = artArea === 'neck' ? q('[data-neck-canvas]') : active;
        if (!artPlanes.has(host)) {
          const plane = document.createElement('div');
          plane.className = 'fm-studio__art-plane';
          const img = document.createElement('img');
          img.className = 'fm-studio__art-image'; img.draggable = false; img.tabIndex = 0; img.alt = copy.art_move;
          plane.append(img); host.append(plane); artPlanes.set(host,plane);
          img.addEventListener('pointerdown', event => {
            if (event.button !== 0 || !artState()) return;
            event.preventDefault(); event.stopPropagation(); img.focus({preventScroll:true});
            img.setPointerCapture(event.pointerId);
            const state = artState();
            const start = {x:event.clientX,y:event.clientY,px:state.x,py:state.y};
            const move = e => {
              const box = plane.getBoundingClientRect();
              state.x = start.px + (e.clientX-start.x)/box.width*100;
              state.y = start.py + (e.clientY-start.y)/box.height*100;
              renderArtwork();
            };
            const end = () => {img.removeEventListener('pointermove',move);img.removeEventListener('pointerup',end);img.removeEventListener('pointercancel',end);};
            img.addEventListener('pointermove',move);img.addEventListener('pointerup',end);img.addEventListener('pointercancel',end);
          });
          img.addEventListener('click',e=>e.stopPropagation());
          img.addEventListener('keydown',e=>{
            const step = e.shiftKey ? 5 : 1; const moves={ArrowLeft:[-step,0],ArrowRight:[step,0],ArrowUp:[0,-step],ArrowDown:[0,step]};
            if (!moves[e.key] || !artState()) return;
            e.preventDefault();e.stopPropagation();artState().x+=moves[e.key][0];artState().y+=moves[e.key][1];renderArtwork();
          });
        }
        return artPlanes.get(host);
      };
      const renderArtwork = () => {
        if (active && window.FormateesStudioPricing) refreshCommerce();
        hideArtwork();
        const state = artState();
        if (!active || !state || q('[data-step=personalization]').hidden) return;
        const plane = planeFor(); const r=region();
        if (artArea === 'neck') {
          if(q('[data-neck-image]').hidden) return;
          Object.assign(plane.style,{left:r.x*100+'%',top:r.y*100+'%',width:r.w*100+'%',height:r.h*100+'%'});
        } else {
          const img=active.querySelector('.fm-studio__model-image');
          if(!img.complete || !img.naturalWidth) return;
          const box=img.getBoundingClientRect(), parent=active.getBoundingClientRect();
          const scale=Math.min(box.width/img.naturalWidth,box.height/img.naturalHeight);
          const w=img.naturalWidth*scale,h=img.naturalHeight*scale;
          Object.assign(plane.style,{left:box.left-parent.left+(box.width-w)/2+w*r.x+'px',top:box.top-parent.top+(box.height-h)/2+h*r.y+'px',width:w*r.w+'px',height:h*r.h+'px'});
        }
        plane.hidden=false;
        const w=plane.clientWidth,h=plane.clientHeight;if(!w||!h)return;
        const angle=state.rotation*Math.PI/180,c=Math.abs(Math.cos(angle)),sn=Math.abs(Math.sin(angle));
        const maxWidth=Math.min(w/(c+sn/state.ratio),h/(sn+c/state.ratio));
        const iw=maxWidth*state.size/100,ih=iw/state.ratio;
        const ex=(iw*c+ih*sn)/2/w*100,ey=(iw*sn+ih*c)/2/h*100;
        state.x=Math.max(ex,Math.min(100-ex,state.x));state.y=Math.max(ey,Math.min(100-ey,state.y));
        const image=plane.firstElementChild;
        if(image.getAttribute('src')!==state.url) image.src=state.url;
        Object.assign(image.style,{left:state.x+'%',top:state.y+'%',width:iw+'px',transform:`translate(-50%,-50%) rotate(${state.rotation}deg)`});
        qa('[data-art-control]').forEach(input=>{input.value=state[input.dataset.artControl];q('[data-art-value="'+input.dataset.artControl+'"]').textContent=Math.round(state[input.dataset.artControl])+(input.dataset.artControl==='rotation'?'°':'%');});
      };
      const selectArtArea = area => {
        if (!active) return;
        if (area === 'back' && q('[data-area="back"]').disabled) area = 'front';
        artTicket++; artArea=area; artFile.value='';
        qa('[data-area]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.area===area)));
        q('[data-neck-detail]').hidden=area!=='neck';
        const neckUrl = avatarCatalog?.[active.dataset.code]?.neck;
        const neckImage = q('[data-neck-image]');
        neckImage.hidden = !neckUrl;
        if (neckUrl) neckImage.src = neckUrl;
        q('[data-neck-rule]').textContent = copy.neck_optional;
        if (area !== 'neck') { currentView = area; renderAvatar(); }
        artStatus.textContent=artState()?.name || copy.art_empty;
        artControls.disabled=!artState();
        refreshCommerce();
        requestAnimationFrame(renderArtwork);
      };
      artFile.addEventListener('change',async()=>{
        const file=artFile.files[0];if(!file||!active)return;
        if(!['image/png','image/jpeg','image/webp'].includes(file.type)||file.size>15*1024*1024){artStatus.textContent=copy.art_error;artFile.value='';return;}
        const key=artKey(),ticket=++artTicket,url=URL.createObjectURL(file);
        const image=new Image();image.src=url;
        try {
          await image.decode();
          if(ticket!==artTicket || key!==artKey()){URL.revokeObjectURL(url);return;}
          const old=artStates.get(key);if(old)URL.revokeObjectURL(old.url);
          artStates.set(key,{file,url,name:file.name,ratio:image.naturalWidth/image.naturalHeight,size:60,rotation:0,x:50,y:50,technique:'DTG'});
          artStatus.textContent=file.name;artControls.disabled=false;renderArtwork();
        } catch {URL.revokeObjectURL(url);artStatus.textContent=copy.art_error;}
      });
      qa('[data-art-control]').forEach(input=>input.addEventListener('input',()=>{if(artState()){artState()[input.dataset.artControl]=Number(input.value);renderArtwork();}}));
      q('[data-art-center]').addEventListener('click',()=>{if(artState()){artState().x=artState().y=50;renderArtwork();}});
      q('[data-art-remove]').addEventListener('click',()=>{artTicket++;if(artState())URL.revokeObjectURL(artState().url);artStates.delete(artKey());selectArtArea(artArea);hideArtwork();});
      const artResize=new ResizeObserver(()=>requestAnimationFrame(renderArtwork));
      blanks.forEach(blank=>{artResize.observe(blank);blank.querySelector('.fm-studio__model-image').addEventListener('load',renderArtwork);});
      artResize.observe(q('[data-neck-canvas]'));
      window.addEventListener('pagehide',event=>{if (!event.persisted) { artStates.forEach(state=>URL.revokeObjectURL(state.url));artResize.disconnect(); }});

      const commerceCopy = JSON.parse(q('[data-commerce-copy]').textContent);
      const money = cents => new Intl.NumberFormat('es-MX',{style:'currency',currency:'MXN'}).format(cents/100);
      const zoneLabel = area => area==='front'?copy.front_view:area==='back'?copy.back_view:commerceCopy.neck;
      const selectedArt = () => ['front','back','neck'].flatMap(area=>{const state=artStates.get(active?.dataset.code+':'+area);return state?[{area,state}]:[];});
      const quoteOnly = () => Boolean(active?.dataset.quoteOnly)||special()&&garments().some(line=>!variants.find(v=>Number(v.id)===line.id)?.available);
      const garments = () => sizeInputs().filter(input=>Number(input.value)>0).map(input=>({id:Number(input.dataset.variantId),quantity:Number(input.value),size:input.dataset.size}));
      const priceBasis = (blank=active,count=value()) => {
        const data=JSON.parse(blank.querySelector('[data-garment-prices]').textContent);
        const assigned=studio.dataset.accountTier;
        const quantity=data.open?count+openCartQuantity:count;
        const tier=data.open?(assigned!=='auto'?assigned:String([10000,5000,1000,100,50,10,1].find(n=>quantity>=n)||1))
          :assigned!=='auto'?assigned:count<10?'1–9':count<50?'10–49':'50+';
        return {data,assigned,quantity,tier};
      };
      const priceBasisText = (basis=priceBasis(),count=value()) => {
        const number=n=>new Intl.NumberFormat('es-MX').format(n);
        const pieces=number(count);
        const tier=basis.data.open&&basis.assigned==='auto'&&basis.quantity<100?(basis.quantity<10?'1–9':basis.quantity<50?'10–49':'50–99'):/^\d+$/.test(basis.tier)?number(Number(basis.tier))+'+':basis.tier;
        const rule=basis.assigned!=='auto'?fill(commerceCopy.account,{tier})
          :fill(commerceCopy.volume,{tier});
        const cart=basis.data.open&&openCartQuantity>0?fill(commerceCopy.cart,{cart:number(openCartQuantity),total:number(basis.quantity)}):'';
        return fill(commerceCopy.quoted,{quantity:pieces,rule})+cart;
      };
      const garmentCents = size => {
        const {data,tier}=priceBasis();
        const category=special()||/crudo|pfd/i.test(option.dataset.name)?'Crudo / PFD':option.dataset.name==='Blanco'?'Blanco':['12030'].includes(active.dataset.code)?'Lavados especiales':'Color';
        const row=data.rows.find(row=>row.category===category&&row.extra===/^(XXL|2XL|3XL|XXXL)(?:$|[–-])/i.test(size));
        if(!row)throw Error(commerceCopy.price_missing);
        return rowPrice(row,priceBasis());
      };
      const rowPrice = (row,basis) => {
        if(basis.data.open)return row.prices[basis.tier];
        const indexes={'100':3,'1000':4,'5000':5,'10000':6};
        const index=basis.data.ringFallback?(indexes[basis.assigned]??(basis.quantity<10?0:basis.quantity<50?1:2))
          :basis.data.tier==='guest'?(basis.quantity<10?0:basis.quantity<50?1:2):0;
        return row.prices[index];
      };
      const cardPrice = blank => {
        const basis=priceBasis(blank,1);
        const options=[...blank.querySelector('template[data-options]').content.querySelectorAll('[data-option]')];
        const categories=new Set(options.map(button=>button.dataset.handle==='lavados-especiales'||/crudo|pfd/i.test(button.dataset.name)?'Crudo / PFD':button.dataset.name==='Blanco'?'Blanco':blank.dataset.code==='12030'?'Lavados especiales':'Color'));
        const prices=basis.data.rows.filter(row=>!row.extra&&categories.has(row.category)).map(row=>rowPrice(row,basis)).filter(n=>Number.isFinite(n)&&n>0);
        if(!prices.length)return null;
        return {amount:Math.min(...prices),basis};
      };
      const refreshEarlyPrice = () => {
        const box=q('[data-early-price]');box.hidden=true;
        if(!active)return;
        try {
          const count=value();
          if(!option||!validQuantity()){
            const reference=option?{amount:garmentCents('S'),basis:priceBasis(active,1)}:cardPrice(active);
            if(!reference)return;
            q('[data-early-total]').textContent='—';q('[data-early-unit]').textContent=fill(commerceCopy.from,{price:money(reference.amount)});
            q('[data-early-basis]').textContent=priceBasisText(reference.basis,1);
            q('[data-early-note]').textContent=commerceCopy.choose_quantity+' '+commerceCopy.details;
          } else {
            let amount=garments().reduce((sum,line)=>sum+garmentCents(line.size)*line.quantity,0);
            if(special()&&wash)amount+=window.FormateesStudioWashRules.quote(active.dataset.code,wash.finish,count).total;
            q('[data-early-total]').textContent=money(amount);q('[data-early-unit]').textContent=money(amount/count);
            q('[data-early-basis]').textContent=priceBasisText();
            q('[data-early-note]').textContent=special()&&!wash?commerceCopy.pending_wash:commerceCopy.details;
          }
          box.hidden=false;
        } catch {box.hidden=true;}
      };
      const configurationQuote = () => {
        if(!active||!option||!validQuantity())throw Error(commerceCopy.quantity_error);
        if(special()&&(!wash||value()<minimum()))throw Error(commerceCopy.wash_error);
        const designs=selectedArt();
        const lines=garments();
        const services=designs.map(({area,state})=>({...window.FormateesStudioPricing.quote(area,state,value(),option.dataset.handle==='blanco'),state}));
        const washService=special()?window.FormateesStudioWashRules.quote(active.dataset.code,wash.finish,value()):null;
        const blankTotal=lines.reduce((sum,line)=>sum+garmentCents(line.size)*line.quantity,0);
        return {lines,services,washService,blankTotal,serviceTotal:services.reduce((sum,g)=>sum+g.total,0)+(washService?.total||0)};
      };
      const refreshCommerce = () => {
        if(!active)return;
        const state=artState();
        q('[data-technique-wrap]').hidden=artArea==='neck';
        q('[data-technique]').disabled=!state;
        q('[data-technique]').value=state?.technique||'DTG';
        q('[data-art-dimensions]').textContent=state&&artArea!=='neck'?(()=>{const s=window.FormateesStudioPricing.size(state);return `${s.width.toFixed(1)} × ${s.height.toFixed(1)} cm · ${commerceCopy.rate_size} ${s.tier} cm`;})():'';
        try { const quote=configurationQuote();const amount=quote.blankTotal+quote.serviceTotal;const count=quote.lines.reduce((sum,line)=>sum+line.quantity,0);q('[data-commerce-total]').textContent=money(amount);q('[data-commerce-unit]').textContent=money(amount/count);q('[data-pricing-basis]').textContent=priceBasisText();q('[data-pricing-basis]').hidden=false;q('[data-commerce-error]').textContent='';q('[data-review]').disabled=false; }
        catch(error){q('[data-pricing-basis]').hidden=true;q('[data-commerce-total]').textContent='—';q('[data-commerce-unit]').textContent='—';q('[data-commerce-error]').textContent=error.message;q('[data-review]').disabled=true;}
      };
      q('[data-technique]').addEventListener('change',event=>{if(artState()){artState().technique=event.target.value;renderArtwork();refreshCommerce();}});
      const review = () => {
        let quote;try{quote=configurationQuote();}catch(error){q('[data-commerce-error]').textContent=error.message;return;}
        q('[data-review-lines]').replaceChildren();
        const addRow=(label,amount)=>{const row=document.createElement('div');const span=document.createElement('span');span.textContent=label;const strong=document.createElement('strong');strong.textContent=amount;row.append(span,strong);q('[data-review-lines]').append(row);};
        q('[data-review-product]').textContent=active.dataset.title+' · '+option.dataset.name+(wash?' · '+copy[wash.finish]+' / '+wash.color:'');
        quote.lines.forEach(line=>addRow(`${line.size} · ${line.quantity} × ${money(garmentCents(line.size))}`,money(line.quantity*garmentCents(line.size))));
        if(quote.washService)addRow(`${copy[wash.finish]} · ${quote.washService.quantity} × ${money(quote.washService.cents)}`,money(quote.washService.total));
        quote.services.forEach(g=>addRow(`${zoneLabel(g.area)} · ${g.technique}${g.area==='neck'?'':` · ${g.width.toFixed(1)} × ${g.height.toFixed(1)} cm`} · ${g.quantity} × ${money(g.cents)}`,money(g.total)));
        q('[data-review-total]').textContent=money(quote.blankTotal+quote.serviceTotal);
        q('[data-review-pricing-basis]').textContent=priceBasisText();
        q('[data-review-taxes]').textContent=washCopy.taxes;
        show('review');q('[data-cart-status]').textContent=active.dataset.label==='open'?openCopy.under_order:quoteOnly()?washCopy.quote_note:'';q('[data-add-cart]').textContent=quoteOnly()?washCopy.request:editSource?editCopy.update_studio:commerceCopy.add_cart;q('[data-add-cart]').disabled=active.dataset.label==='open'&&studio.dataset.openPricingReady!=='true';if(q('[data-add-cart]').disabled){q('[data-add-cart]').textContent=openCopy.pending;q('[data-cart-status]').textContent=openCopy.pending;}
      };
      q('[data-review]').addEventListener('click',review);
      q('[data-review-back]').addEventListener('click',()=>show('personalization'));
      let cartBusy=false;
      const shopRoot=window.Shopify?.routes?.root||'/';
      const readResponse=async response=>{let data;try{data=await response.json();}catch{throw Error(commerceCopy.cart_error);}if(!response.ok)throw Error(data.description||data.message||commerceCopy.cart_error);return data;};
      const refreshOpenCart=async()=>{try{const cart=await fetchCart();openCartQuantity=cart.items.filter(i=>openProductIds.has(Number(i.product_id))&&!editSource?.items.some(old=>editIdentity(old)===editIdentity(i))).reduce((n,i)=>n+i.quantity,0);}catch{openCartQuantity=0;}if(active){refreshEarlyPrice();if(!q('[data-step=personalization]').hidden)refreshCommerce();}};
      const fetchCart=()=>fetch(shopRoot+'cart.js',{headers:{Accept:'application/json'},cache:'no-store'}).then(readResponse);
      q('[data-add-cart]').addEventListener('click',async()=>{
        if(cartBusy)return;
        if(editToken&&(editRestoreFailed||!editSource)){q('[data-cart-status]').textContent=editCopy.edit_failed;return;}
        if(editSource){try{verifyOriginals(await fetchCart());}catch(error){q('[data-cart-status]').textContent=error.message;return;}}
        if(active?.dataset.label==='open'&&studio.dataset.openPricingReady!=='true')return;
        await refreshOpenCart();
        let quote;try{quote=configurationQuote();}catch(error){q('[data-cart-status]').textContent=error.message;return;}
        if(quoteOnly()){const detail=[q('[data-review-product]').textContent,...Array.from(q('[data-review-lines]').children,row=>row.textContent),'Total: '+money(quote.blankTotal+quote.serviceTotal),'IVA incluido. Flete no incluido. Tallas y disponibilidad por confirmar.',q('[data-special-instructions]').value,...selectedArt().map(({area,state})=>zoneLabel(area)+': '+state.name)].join('\n');location.href='mailto:formateesco@gmail.com?subject='+encodeURIComponent('Cotización Studio · '+active.dataset.title)+'&body='+encodeURIComponent(detail);return;}
        cartBusy=true;artTicket++;studio.inert=true;
        const button=q('[data-add-cart]'),status=q('[data-cart-status]');button.disabled=true;status.textContent=commerceCopy.adding;
        const configurationId='STUDIO-'+crypto.randomUUID();
        const instructions=q('[data-special-instructions]').value.trim();
        const props={'_Configuración':configurationId,'Estilo':active.dataset.code,...(instructions?{'Instrucciones especiales':instructions}:{})};
        if(wash){props['Lavado especial']=copy[wash.finish]||wash.finish;props['Color de lavado']=wash.color;}
        props['_StudioState']=JSON.stringify({version:1,model:active.dataset.code,option:option.dataset.handle,optionName:option.dataset.name,wash:wash?{finish:wash.finish,color:wash.color,index:wash.index}:null});
        const expected=[];let replacementVerified=false;
        try {
          const items=quote.lines.map(line=>({id:line.id,quantity:line.quantity,properties:{...props,'Personalización':quote.services.length?commerceCopy.with_design:commerceCopy.no_design}}));
          if(quote.washService)items.push({id:Number(quote.washService.variantId),quantity:quote.washService.quantity,properties:{...props,Servicio:'Lavado especial','Precio unitario':money(quote.washService.cents),'_StudioWash':'true'}});
          expected.push(...items.map(x=>({id:x.id,quantity:x.quantity,area:null})));
          await fetch(shopRoot+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items})}).then(readResponse);
          for(const service of quote.services){
            const state=service.state,form=new FormData();form.append('id',service.variantId);form.append('quantity',String(service.quantity));
            const fields={...props,'Servicio':commerceCopy.personalization,'Nombre del archivo':state.name,'Técnica':service.technique,'Ubicación':zoneLabel(service.area),'Color':option.dataset.name,'Tamaño':service.area==='neck'?commerceCopy.neck:`${service.width.toFixed(1)} × ${service.height.toFixed(1)} cm`,'Precio unitario':money(service.cents),'Volumen calculado':String(service.quantity)+(service.quantity>=500?' · 500+':''),'_StudioArea':service.area,'_Posición diseño':JSON.stringify({area:service.area,x:state.x,y:state.y,size:state.size,rotation:state.rotation,width_cm:service.area==='neck'?null:service.width,height_cm:service.area==='neck'?null:service.height,region:region(service.area),model:active.dataset.code,version:1})};
            for(const [key,val]of Object.entries(fields))form.append('properties['+key+']',val);
            form.append('properties[Archivo]',state.file,state.name);
            await fetch(shopRoot+'cart/add.js',{method:'POST',headers:{Accept:'application/json'},body:form}).then(readResponse);
            expected.push({id:Number(service.variantId),quantity:service.quantity,area:service.area});
          }
          const cart=await fetchCart();const saved=cart.items.filter(item=>item.properties?.['_Configuración']===configurationId);
          const savedTotal=saved.reduce((sum,i)=>sum+i.final_line_price,0);
          const quotedTotal=quote.blankTotal+quote.serviceTotal;
          // Sami applies Open Label tier prices when its checkout is created.
          // Ajax may still return native garment prices; services must stay exact.
          const nativeGarments=quote.lines.map(line=>({line,variant:variants.find(v=>Number(v.id)===Number(line.id))}));
          const samiNativeTotal=active.dataset.label==='open'&&nativeGarments.every(({variant})=>variant&&Number.isInteger(variant.price))
            ?nativeGarments.reduce((sum,{line,variant})=>sum+variant.price*line.quantity,0)+quote.serviceTotal:null;
          if(!editSource&&savedTotal!==quotedTotal&&savedTotal!==samiNativeTotal)throw Error(washCopy.price_mismatch);
          if(editSource&&saved.filter(i=>i.properties?.Servicio).reduce((sum,i)=>sum+i.final_line_price,0)!==quote.serviceTotal)throw Error(washCopy.price_mismatch);
          if(saved.length!==expected.length||expected.some(e=>!saved.some(i=>Number(i.variant_id)===e.id&&i.quantity===e.quantity&&(i.properties?._StudioArea||null)===e.area&&(!e.area||/^(https?:)?\/\//.test(i.properties.Archivo)))))throw Error(commerceCopy.verify_error);
          replacementVerified=true;
          if(editSource){
            verifyOriginals(cart);
            const originals=editOriginals(cart);
            await fetch(shopRoot+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({updates:Object.fromEntries(originals.map(i=>[i.key,0]))})}).then(readResponse);
            const check=await fetchCart();
            if(editOriginals(check).length||check.items.filter(i=>i.properties?.['_Configuración']===configurationId).length!==saved.length)throw Error(editCopy.edit_cleanup);
            try{sessionStorage.removeItem('fm-cart-edit:'+editToken);}catch{}
          }
          status.textContent=commerceCopy.cart_success;
          location.assign(shopRoot+'cart');
        }catch(error){
          if(replacementVerified&&editSource){
            try{const current=await fetchCart();const retained=editOriginals(current);if(retained.length!==editSource.items.length){sessionStorage.setItem('fm-cart-message',editCopy.edit_cleanup);location.assign(shopRoot+'cart');return;}}catch{try{sessionStorage.setItem('fm-cart-message',editCopy.edit_cleanup);}catch{}location.assign(shopRoot+'cart');return;}
          }
          let rolledBack=false;
          try {const cart=await fetchCart();const updates=Object.fromEntries(cart.items.filter(i=>i.properties?.['_Configuración']===configurationId).map(i=>[i.key,0]));if(Object.keys(updates).length)await fetch(shopRoot+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({updates})}).then(readResponse);const check=await fetchCart();rolledBack=!check.items.some(i=>i.properties?.['_Configuración']===configurationId);}catch{}
          status.textContent=error.message+' '+(rolledBack?commerceCopy.rolled_back:commerceCopy.check_cart);button.disabled=!rolledBack;
          cartBusy=false;studio.inert=false;
        }
      });
      const roster=q('.fm-studio__roster');
      const updateCarousel=()=>{const card=Array.from(roster.children).find(c=>!c.hidden);if(card&&q('[data-carousel-current]'))q('[data-carousel-current]').textContent=String(Math.floor(roster.scrollLeft/Math.max(1,card.getBoundingClientRect().width))+1).padStart(2,'0');q('[data-carousel-prev]').disabled=roster.scrollLeft<2;q('[data-carousel-next]').disabled=roster.scrollLeft+roster.clientWidth>=roster.scrollWidth-2;};
      qa('[data-carousel]').forEach(button=>button.addEventListener('click',()=>roster.scrollBy({left:roster.clientWidth*(button.dataset.carousel==='next'?1:-1),behavior:'instant'})));
      roster.addEventListener('scroll',updateCarousel,{passive:true});new ResizeObserver(updateCarousel).observe(roster);updateCarousel();

      const previewImage = () => renderAvatar();

      const sizeInputs = () => [...matrix.querySelectorAll('input:not(:disabled)')];
      const value = () => sizeInputs().reduce((sum, input) => sum + Number(input.value || 0), 0);
      const validQuantity = () => sizeInputs().every(input => Number.isInteger(Number(input.value)) && Number(input.value) >= 0) && value() >= 1 && value() <= 1000000;
      const special = () => option?.dataset.handle === 'lavados-especiales';
      const minimum = () => Number(active?.dataset.washMinimum || 0);
      const fill = (source, values) => Object.entries(values).reduce((result, pair) => result.replaceAll('[' + pair[0] + ']', pair[1]), source || '');
      const show = name => {
        qa('[data-step]').forEach(step => step.hidden = step.dataset.step !== name);
        const number = name === 'review' ? '05' : name === 'finish' ? '02' : name === 'washes' ? '03' : special() ? '04' : '03';
        progress.textContent = number;
        panelStep.textContent = number + ' / 05';
        title.textContent = name === 'review' ? commerceCopy.review : copy[name];
        if (name === 'personalization') { selectArtArea(artArea); refreshCommerce(); }
        else hideArtwork();
        if(name==='finish')refreshEarlyPrice();
        panel.scrollTop=0;
        if(window.matchMedia('(max-width:989px)').matches){
          requestAnimationFrame(()=>{
            panel.scrollIntoView({block:'start',behavior:'instant'});
            title.setAttribute('tabindex','-1');title.focus({preventScroll:true});
          });
        }
      };
      const validate = () => {
        total.textContent = Number.isFinite(value()) ? value().toLocaleString('es-MX') : '0';
        const required = special() ? minimum() : 1;
        next.disabled = !option || !validQuantity() || value() < required;
        minimumHint.textContent = special()?fill(copy.minimum,{minimum:required}):active?.dataset.label==='open'?openCopy.under_order:copy.quantity_hint;
        nextText.textContent = special() ? copy.view_washes : copy.continue;
        error.textContent = option && value() < required ? (special() ? fill(copy.missing, { minimum: required, missing: required - value() }) : commerceCopy.quantity_error) : '';
        refreshEarlyPrice();
      };
      const reset = () => {
        if (cartBusy) return;
        hideArtwork();
        const previous = active;
        studio.classList.remove('is-detail');
        q('[data-view-controls]').hidden = true;
        q('[data-neck-detail]').hidden = true;
        currentView = 'front';
        blanks.forEach(blank => { blank.classList.remove('is-selected'); blank.inert = false; blank.style.transform = ''; restoreImage(blank); });
        panel.setAttribute('aria-hidden', 'true');
        panel.inert = true;
        target.replaceChildren();
        washGallery.replaceChildren();
        active = option = wash = null;
        matrix.replaceChildren();
        quantities.clear();
        total.textContent = '0';
        selection.textContent = emptySelection;
        washSelection.textContent = emptySelection;
        show('finish');
        progress.textContent = '01';
        previous?.querySelector('[data-choose]').focus({ preventScroll: true });
      };
      const washCards = () => {
        const api = window.FormateesStudioWashRules;
        if (!api) return setTimeout(washCards, 80);
        washGallery.replaceChildren();
        washNext.disabled = !wash;
        Object.entries(api.finishes).forEach(([finish, colors], row) => {
          const group = document.createElement('section');
          group.className = 'fm-studio__wash-group';
          const heading = document.createElement('h3');
          const definition=api.types.find(t=>t.id===finish);const fee=api.quote(active.dataset.code,finish,1);heading.textContent=(copy[finish]||finish)+' · '+washCopy[definition.group]+' · +'+money(fee.cents)+' / '+washCopy.unit;
          const description = document.createElement('p');
          description.textContent = copy[finish + '_description'] || '';
          const grid = document.createElement('div');
          grid.className = 'fm-studio__wash-grid';
          colors.forEach((color, column) => {
            const button = document.createElement('button');
            button.type = 'button';
            button.className = 'fm-studio__wash-option';
            button.setAttribute('aria-pressed', String(wash?.finish === finish && wash?.color === color));
            const media = window.FormateesStudioWashMedia?.[active.dataset.code]?.[finish]?.[column];
            if (media) {
              const image = document.createElement('img');
              image.src = media;
              image.loading = 'lazy';
              image.alt = '';
              button.append(image);
            } else {
              const ns = 'http://www.w3.org/2000/svg';
              const svg = document.createElementNS(ns, 'svg');
              svg.setAttribute('viewBox', (297 + 104.3 * column) + ' ' + (190 + 195 * row) + ' 102 102');
              const image = document.createElementNS(ns, 'image');
              image.setAttribute('href', studio.dataset.catalog);
              image.setAttribute('width', '1404');
              image.setAttribute('height', '993');
              svg.append(image);
              button.append(svg);
            }
            const label = document.createElement('span');
            label.textContent = color;
            button.append(label);
            button.addEventListener('click', () => {
              washGallery.querySelectorAll('[aria-pressed=true]').forEach(item => item.setAttribute('aria-pressed', 'false'));
              button.setAttribute('aria-pressed', 'true');
              wash = { finish, color, media, index: column };
              if (!avatarEntry()?.[currentView]) currentView = 'front';
              previewImage(media, (copy[finish] || finish) + ' · ' + color);
              washSelection.textContent = (copy[finish] || finish) + ' · ' + color;
              washNext.disabled = false;
              refreshEarlyPrice();
            });
            grid.append(button);
          });
          group.append(heading, description, grid);
          washGallery.append(group);
        });
      };
      const renderMatrix = () => {
        matrix.replaceChildren();
        const sizes = [...new Set(variants.map(v => v.options[sizeIndex]).filter(Boolean))];
        const table = document.createElement('table');
        table.style.minWidth = (sizes.length * 48) + 'px';
        const head = table.createTHead().insertRow();
        const row = table.createTBody().insertRow();
        sizes.forEach(size => {
          const header = document.createElement('th');
          header.scope = 'col';
          header.textContent = size;
          head.append(header);
          const input = document.createElement('input');
          input.type = 'number'; input.min = '0'; input.max = '1000000'; input.step = '1'; input.inputMode = 'numeric';
          input.setAttribute('aria-label', copy.size_quantity + ' ' + size);
          input.dataset.size = size;
          const variant = variants.find(v => (special()? /crudo|pfd/i.test(v.options[0]):v.options[0]===option?.dataset.name) && v.options[sizeIndex] === size);
          input.disabled = !variant || !variant.available&&!special()&&!active.dataset.quoteOnly;
          if (variant) input.dataset.variantId = variant.id;
          const key = (option?.dataset.name || '') + '|' + size;
          input.value = input.disabled ? '0' : quantities.get(key) || '0';
          if (input.disabled) quantities.delete(key);
          input.addEventListener('input', () => { quantities.set(key, input.value); validate(); });
          const cell = row.insertCell();
          cell.dataset.sizeLabel=size;
          cell.append(input);
          if (variant && (!variant.available||active.dataset.underOrder)) {
            const label = document.createElement('small');
            label.textContent = special()||active.dataset.underOrder?washCopy.backorder:commerceCopy.sold_out;
            input.title = special()||active.dataset.underOrder||active.dataset.quoteOnly?washCopy.backorder:commerceCopy.sold_out;
            cell.append(label);
          }
        });
        matrix.append(table);
      };
      const refreshOptionMockups = () => {
        if(!active)return;
        const catalog=avatarCatalog[active.dataset.code]||{};
        const resolve=source=>source==='original'?originalImages.get(active)?.src:source;
        target.querySelectorAll('[data-option]').forEach(button=>{
          const host=button.querySelector('span');if(!host)return;
          if(button.dataset.handle==='lavados-especiales'){
            const samples=['mineral:5','pp_spray:3','sunfade:7'].map(key=>({key,source:resolve(catalog[key]?.front)})).filter(item=>item.source);
            if(!samples.length)return;
            host.classList.add('fm-studio__wash-preview');host.replaceChildren();
            samples.forEach(({key,source})=>{const image=document.createElement('img');image.src=source;image.alt=copy[key.split(':')[0]]||'';image.width=70;image.height=105;image.loading='lazy';host.append(image);});
            const label=button.querySelector('em');label.textContent=button.dataset.name;label.title=button.dataset.name;
          } else {
            const entry=catalog['base:'+button.dataset.handle]||(/crudo|pfd/i.test(button.dataset.name)?catalog['base:blanco']:null);
            const source=resolve(entry?.front);if(!source)return;
            let image=host.querySelector('img');if(!image){image=document.createElement('img');host.replaceChildren(image);}
            const url=new URL(source,location.origin);if(url.hostname==='cdn.shopify.com')url.searchParams.set('width','180');
            image.src=url.href;image.removeAttribute('srcset');image.removeAttribute('sizes');image.alt=button.dataset.name;image.width=90;image.height=135;image.loading='lazy';
          }
        });
      };
      const bindOptions = () => {
        refreshOptionMockups();
        [...target.querySelectorAll('[data-option]')].forEach(button => {
          if (button.dataset.handle === 'lavados-especiales' && !minimum()) return button.remove();
          button.addEventListener('click', () => {
            target.querySelectorAll('[data-option]').forEach(item => item.setAttribute('aria-pressed', 'false'));
            button.setAttribute('aria-pressed', 'true');
            if (option !== button) {
              wash = null;
              washSelection.textContent = emptySelection;
              washNext.disabled = true;
            }
            option = button;
            if (!avatarEntry()?.[currentView]) currentView = 'front';
            previewImage(wash?.media || button.dataset.image, wash ? (copy[wash.finish] || wash.finish) + ' · ' + wash.color : button.dataset.name);
            renderMatrix();
            selection.textContent = button.dataset.name;
            validate();
          });
        });
      };

      blanks.forEach(blank => blank.querySelector('[data-choose]')?.addEventListener('click', () => {
        if (active === blank) return;
        const origin = blank.getBoundingClientRect();
        active = blank;
        currentView = 'front';
        q('[data-view-controls]').hidden = false;
        variants = JSON.parse(blank.querySelector('[data-variants]').textContent);
        const names = JSON.parse(blank.querySelector('[data-option-names]').textContent);
        sizeIndex = names.findIndex(name => /talla|size/i.test(name));
        if (sizeIndex < 0) sizeIndex = 1;
        option = wash = null;
        matrix.replaceChildren();
        quantities.clear();
        total.textContent = '0';
        blanks.forEach(item => item.classList.toggle('is-selected', item === blank));
        studio.classList.add('is-detail');
        blanks.forEach(item => item.inert = item !== blank);
        if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          const destination = blank.getBoundingClientRect();
          blank.animate([
            { transformOrigin: '0 0', transform: `translate(${origin.left - destination.left}px,${origin.top - destination.top}px) scale(${origin.width / destination.width},${origin.height / destination.height})` },
            { transformOrigin: '0 0', transform: 'none' }
          ], { duration: 650, easing: 'cubic-bezier(.16,.8,.25,1)' });
        }
        if(blank.dataset.liveProduct&&studio.dataset.openPricingReady==='true'){variants=[];variantLoad=fetch(shopRoot+'products/'+blank.dataset.liveProduct+'.js',{headers:{Accept:'application/json'},cache:'no-store'}).then(readResponse).then(p=>{if(active!==blank)return;variants=p.variants;renderMatrix();validate();}).catch(()=>{if(active===blank){variants=[];renderMatrix();validate();error.textContent=openCopy.unavailable;}});}
        panel.querySelector('[data-code]').textContent = blank.dataset.code;
        panel.querySelector('[data-title]').textContent = blank.dataset.title;
        selection.textContent = emptySelection;
        target.replaceChildren(blank.querySelector('template[data-options]').content.cloneNode(true));
        if(minimum()&&!target.querySelector('[data-handle="lavados-especiales"]')){const button=document.createElement('button');button.type='button';button.className='fm-studio__option';button.dataset.option='';button.dataset.handle='lavados-especiales';button.dataset.name='Lavados especiales';button.setAttribute('aria-pressed','false');button.innerHTML='<span>◌</span><em>Lavados especiales</em>';target.append(button);}
        bindOptions();
        renderMatrix();
        validate();
        show('finish');
        renderAvatar();
        panel.setAttribute('aria-hidden', 'false');
        panel.inert = false;
        q('[data-close]').focus({ preventScroll: true });
      }));
      qa('[data-view]').forEach(button => button.addEventListener('click', () => {
        if (!active || button.disabled) return;
        currentView = button.dataset.view;
        if (!q('[data-step=personalization]').hidden) selectArtArea(currentView);
        renderAvatar();
      }));
      qa('[data-area]').forEach(button => button.addEventListener('click', () => selectArtArea(button.dataset.area)));
      studio.addEventListener('keydown', event => { if (event.key === 'Escape' && active && !dialog) reset(); });
      dialog?.addEventListener('cancel', event => { if (cartBusy) event.preventDefault(); });
      q('[data-close]').addEventListener('click', reset);
      q('[data-exit]').addEventListener('click', () => {
        if (cartBusy) return;
        if (inline) return reset();
        if (dialog) return dialog.close();
        if (studio.classList.contains('is-detail')) return reset();
        const destination = new URLSearchParams(location.search).get('origen') === 'proyectos' ? 'marcas-y-uniformes' : 'personaliza-tus-blanks';
        location.assign(shopRoot + 'pages/' + destination);
      });
      next.addEventListener('click', () => {
        validate();
        if (next.disabled) return;
        if (!special()) return show('personalization');
        q('[data-wash-intro]').textContent = fill(copy.wash_intro, { minimum: minimum(), quantity: value() });
        washCards();
        show('washes');
      });
      washNext.addEventListener('click', () => { if (wash) show('personalization'); });
      q('[data-back-finish]').addEventListener('click', () => show('finish'));
      q('[data-back-personalization]').addEventListener('click', () => show(special() ? 'washes' : 'finish'));
      const selectEntryModel = code => {
        const chosen = blanks.find(blank => blank.dataset.code === code);
        const button = chosen?.querySelector('[data-choose]');
        if (!button || button.disabled || active === chosen || cartBusy) return;
        if (active) reset();
        if(chosen.hidden)setLabel(chosen.dataset.label||'ring');
        button.click();
      };
      studio.addEventListener('formatees:studio-select', event => selectEntryModel(event.detail?.model));
      const showroomModels=JSON.parse(q('[data-showroom-models]').textContent),showroomCopy=JSON.parse(q('[data-showroom-copy]').textContent);
      blanks.forEach(blank=>{const ref=showroomModels.find(m=>m.code===blank.dataset.code);if(!ref)return;const name=blank.querySelector('.fm-studio__name');if(name){name.querySelector('h2').textContent=ref.title;name.querySelector('span').textContent=ref.meta;name.querySelector('p').textContent=showroomCopy.language.startsWith('es')?ref.description:ref.description_en;}const img=blank.querySelector('.fm-studio__model-image');if(img){img.src=ref.image;img.removeAttribute('srcset');img.alt=ref.title;originalImages.set(blank,{src:ref.image,srcset:null,alt:ref.title});}});
      const setLabel=label=>{if(!['ring','open'].includes(label)||cartBusy)return;if(active)reset();studio.dataset.collection=label;q('[data-collection-eyebrow]').textContent=showroomCopy[label+'_eyebrow'];q('.fm-studio__intro h1,.fm-studio__intro h2').textContent=label==='open'?'Open Label':'Ring Label';q('[data-collection-description]').textContent=showroomCopy[label+'_description'];blanks.forEach(b=>b.hidden=(b.dataset.label||'ring')!==label);qa('[data-studio-label]').forEach(b=>b.setAttribute('aria-selected',String(b.dataset.studioLabel===label)));q('[data-carousel-count]').textContent=blanks.filter(b=>!b.hidden).length;roster.scrollLeft=0;updateCarousel();};
      qa('[data-studio-label]').forEach(button=>button.addEventListener('click',()=>setLabel(button.dataset.studioLabel)));
      const entryCode=new URLSearchParams(location.search).get('modelo')||studio.dataset.currentProduct;setLabel(new URLSearchParams(location.search).get('coleccion')==='open'||blanks.find(b=>b.dataset.code===entryCode)?.dataset.label==='open'?'open':'ring');
      
      refreshOpenCart();
      if (!dialog) selectEntryModel(entryCode);
      const restoreCartEdit=async()=>{
        if(!editToken||dialog)return;
        try{
          if(editRestoreFailed||!editSource)throw Error(editCopy.edit_failed);
          const current=await fetchCart();verifyOriginals(current);
          const serviceLine=item=>Boolean(item.properties?.Servicio||item.properties?._StudioArea||item.properties?._StudioWash);
          const pieces=editSource.items.filter(i=>!serviceLine(i));if(!pieces.length)throw Error(editCopy.edit_failed);
          const first=pieces[0];let snapshot={};try{snapshot=JSON.parse(first.properties?._StudioState||'{}');}catch{}
          const code=snapshot.model||first.properties?.Estilo||editSource.product?.code;
          selectEntryModel(String(code));await variantLoad;if(!active||active.dataset.code!==String(code))throw Error(editCopy.edit_failed);
          const desired=snapshot.optionName||first.options_with_values?.find(v=>/color/i.test(v.name))?.value||first.variant_options?.[0]||first.options_with_values?.[0]?.value;
          const isWash=Boolean(first.properties?.['Lavado especial']);
          const chosen=[...target.querySelectorAll('[data-option]')].find(b=>isWash?b.dataset.handle==='lavados-especiales':b.dataset.handle===snapshot.option||b.dataset.name===desired);
          if(!chosen)throw Error(editCopy.edit_failed);chosen.click();
          for(const item of pieces){const input=matrix.querySelector('[data-variant-id="'+item.variant_id+'"]');if(!input||input.disabled)throw Error(editCopy.edit_failed);input.value=String(item.quantity);input.dispatchEvent(new Event('input',{bubbles:true}));}
          if(isWash){
            if(!window.FormateesStudioWashRules||!window.FormateesStudioWashMedia)throw Error(editCopy.edit_failed);
            const finish=snapshot.wash?.finish||Object.keys(window.FormateesStudioWashRules.finishes).find(f=>String(copy[f]||f).toLowerCase()===String(first.properties['Lavado especial']).toLowerCase());
            const colors=window.FormateesStudioWashRules.finishes[finish];const color=snapshot.wash?.color||first.properties['Color de lavado'];const index=colors?.indexOf(color);if(index===undefined||index<0)throw Error(editCopy.edit_failed);
            wash={finish,color,index,media:window.FormateesStudioWashMedia?.[code]?.[finish]?.[index]};washSelection.textContent=(copy[finish]||finish)+' · '+color;washNext.disabled=false;
          }
          for(const item of editSource.items.filter(i=>i.properties?._StudioArea)){
            const prop=item.properties;const area=prop._StudioArea;if(!['front','back','neck'].includes(area))throw Error(editCopy.edit_failed);
            const position=JSON.parse(prop['_Posición diseño']);const url=new URL(prop.Archivo,location.origin);if(!['https:','http:'].includes(url.protocol))throw Error(editCopy.edit_failed);
            const response=await fetch(url.href);if(!response.ok)throw Error(editCopy.edit_failed);const blob=await response.blob();if(!blob.type.startsWith('image/'))throw Error(editCopy.edit_failed);
            const name=prop['Nombre del archivo']||editCopy.old_file;const file=new File([blob],name,{type:blob.type});const objectURL=URL.createObjectURL(file);const img=new Image();img.src=objectURL;await img.decode();
            artStates.set(code+':'+area,{file,url:objectURL,name,ratio:img.naturalWidth/img.naturalHeight,size:Number(position.size),rotation:Number(position.rotation),x:Number(position.x),y:Number(position.y),technique:prop.Técnica||'DTG'});
          }
          q('[data-special-instructions]').value=first.properties?.['Instrucciones especiales']||'';
          validate();renderAvatar();show('personalization');selectArtArea('front');
          const notice=document.createElement('p');notice.className='fm-studio__cart-edit-notice';notice.textContent=editCopy.edit_loaded;q('[data-step=personalization]').prepend(notice);
          if(inline)studio.scrollIntoView({block:'start',behavior:'instant'});
        }catch(error){editRestoreFailed=true;error=error?.message||editCopy.edit_failed;const notice=document.createElement('p');notice.setAttribute('role','alert');notice.className='fm-studio__cart-edit-notice';notice.textContent=error;studio.prepend(notice);q('[data-add-cart]').disabled=true;}
      };
      restoreCartEdit();

      fetch(studio.dataset.avatarCatalog)
        .then(response => { if (!response.ok) throw new Error('Avatar catalog unavailable'); return response.json(); })
        .then(catalog => { avatarCatalog = catalog; avatarCatalogReady = true; refreshOptionMockups(); renderAvatar(); })
        .catch(() => { avatarCatalogReady = true; q('[data-avatar-status]').textContent = copy.avatar_error; });
    };
    const mount = studio => { if (studio && !studio.closest('[data-fm-studio-dialog]')) init(studio); };
    document.querySelectorAll('[data-fm-studio]').forEach(mount);
    document.addEventListener('shopify:section:load', event => mount(event.target.querySelector('[data-fm-studio]')));
    document.addEventListener('formatees:studio-open', event => {
      const dialog = event.target.closest('[data-fm-studio-dialog]');
      if (!dialog) return;
      const studio = dialog.querySelector('[data-fm-studio]');
      if (!dialog.dataset.bound) {
        dialog.dataset.bound = 'true';
        dialog.addEventListener('close', () => {
          document.documentElement.classList.remove('fm-configurator-active');
          document.body.classList.remove('fm-configurator-active');
        });
      }
      dialog.showModal();
      init(studio);
      document.documentElement.classList.add('fm-configurator-active');
      document.body.classList.add('fm-configurator-active');
      if (event.detail?.model) studio.dispatchEvent(new CustomEvent('formatees:studio-select', { detail: event.detail }));
    });
    window.addEventListener('pagehide', () => {
      document.documentElement.classList.remove('fm-configurator-active');
      document.body.classList.remove('fm-configurator-active');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["formatees-home-dual"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.fd__hero').forEach((hero) => {
    const track = hero.querySelector('.fd__paths');
    const buttons = Array.from(hero.querySelectorAll('[data-fd-path]'));
    let ticking = false;

    const update = () => {
      const index = Math.round(track.scrollLeft / track.clientWidth);
      buttons.forEach((button, buttonIndex) => {
        button.setAttribute('aria-current', buttonIndex === index ? 'true' : 'false');
      });
      ticking = false;
    };

    buttons.forEach((button, index) => {
      button.addEventListener('click', () => {
        track.scrollTo({ left: index * track.clientWidth, behavior: 'smooth' });
      });
    });

    track.addEventListener('scroll', () => {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }, { passive: true });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["formatees-landing"] && !Shopify.designMode) return;
  try {
    

(() => {
  const init = () => document.querySelectorAll('[data-fm-landing]').forEach(root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const params = new URLSearchParams(location.search);
    const trackingKeys = ['utm_source','utm_medium','utm_campaign','utm_content','utm_term','campaign_id','adset_id','ad_id'];
    const tracking = new URLSearchParams();
    trackingKeys.forEach(key => {
      const value = (params.get(key) || '').trim().slice(0,200);
      if (value) tracking.set(key,value);
    });
    const preview = params.get('preview_theme_id');
    root.querySelectorAll('a[href]').forEach(link => {
      const href = link.getAttribute('href');
      if (!href || href.startsWith('#')) return;
      const url = new URL(link.href,location.origin);
      if (url.origin !== location.origin) return;
      if (preview && /^\d+$/.test(preview)) url.searchParams.set('preview_theme_id',preview);
      if (url.pathname.startsWith('/pages/') || url.pathname.startsWith('/products/')) {
        tracking.forEach((value,key) => { if (!url.searchParams.has(key)) url.searchParams.set(key,value); });
      }
      link.href = url.href;
    });

    const setText = (selector,text) => { const el=root.querySelector(selector); if(el && text) el.textContent=text; };
    const cards = Array.from(root.querySelectorAll('[data-fl-use]'));
    const filterCards = (value,kind) => cards.forEach(card => { card.hidden = value !== 'all' && card.dataset[kind] !== value; });
    root.querySelectorAll('[data-fl-business]').forEach(link => link.addEventListener('click',() => {
      root.querySelectorAll('[data-fl-business]').forEach(item=>item.setAttribute('aria-pressed',String(item===link)));
      setText('[data-fl-business-title]',link.dataset.heading);
      setText('[data-fl-business-copy]',link.dataset.copy);
      setText('[data-fl-products-title]',link.dataset.productsTitle);
    }));
    const defaultProject = {
      title: root.querySelector('[data-fl-products-title]')?.textContent,
      heading: root.querySelector('[data-fl-project-title]')?.textContent,
      copy: root.querySelector('[data-fl-project-copy]')?.textContent,
      cta: root.querySelector('[data-fl-project-cta]')?.textContent
    };
    const rememberChoice = (key, value) => {
      const url = new URL(location.href);
      if (value === 'all') url.searchParams.delete(key); else url.searchParams.set(key, value);
      history.replaceState(history.state, '', url.href);
    };
    const applyProject = value => {
      const selected=root.querySelector('[data-fl-project="'+value+'"]');
      if(!selected && value !== 'all') return;
      root.querySelectorAll('[data-fl-project]').forEach(link=>link.setAttribute('aria-pressed',String(link===selected)));
      root.querySelectorAll('[data-fl-project-filter]').forEach(item=>item.setAttribute('aria-pressed',String(item.dataset.flProjectFilter===value)));
      setText('[data-fl-project-title]',selected?.dataset.title || defaultProject.heading);
      setText('[data-fl-project-copy]',selected?.dataset.copy || defaultProject.copy);
      setText('[data-fl-project-cta]',selected?.dataset.cta || defaultProject.cta);
      setText('[data-fl-products-title]',selected?.dataset.productsTitle || defaultProject.title);
      root.querySelectorAll('.fl__product a[href]').forEach(link => {
        const url = new URL(link.href);
        if(value === 'all') url.searchParams.delete('enfoque'); else url.searchParams.set('enfoque',value);
        link.href = url.href;
      });

    };
    root.querySelectorAll('[data-fl-project]').forEach(link=>link.addEventListener('click',()=>{
      applyProject(link.dataset.flProject);
      rememberChoice('enfoque',link.dataset.flProject);
      root.querySelector('#fm-products')?.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});
    }));
    root.querySelectorAll('[data-fl-project-filter]').forEach(button=>button.addEventListener('click',()=>{
      applyProject(button.dataset.flProjectFilter);
      rememberChoice('enfoque',button.dataset.flProjectFilter);
    }));
    root.querySelectorAll('[data-fl-filter]').forEach(button=>button.addEventListener('click',()=>{
      root.querySelectorAll('[data-fl-filter]').forEach(item=>item.setAttribute('aria-pressed',String(item===button)));
      filterCards(button.dataset.flFilter,'flGarment');
      rememberChoice('prenda',button.dataset.flFilter);
    }));
    root.querySelectorAll('[data-fl-showcase]').forEach(button=>button.addEventListener('click',()=>{
      const value=button.dataset.flShowcase;
      root.querySelectorAll('[data-fl-showcase]').forEach(item=>item.setAttribute('aria-selected',String(item===button)));
      root.querySelectorAll('[data-fl-showcase-panel]').forEach(panel=>{ panel.hidden=panel.dataset.flShowcasePanel!==value; });
    }));
    const retailTrack=root.querySelector('[data-fl-retail-track]');
    const retailDots=Array.from(root.querySelectorAll('[data-fl-retail-slide]'));
    if(retailTrack && retailDots.length){
      let retailTicking=false;
      const updateRetail=()=>{
        const index=Math.round(retailTrack.scrollLeft/retailTrack.clientWidth);
        retailDots.forEach((dot,dotIndex)=>dot.setAttribute('aria-current',String(dotIndex===index)));
        retailTicking=false;
      };
      retailDots.forEach((dot,index)=>dot.addEventListener('click',()=>retailTrack.scrollTo({left:index*retailTrack.clientWidth,behavior:'smooth'})));
      retailTrack.addEventListener('scroll',()=>{if(!retailTicking){requestAnimationFrame(updateRetail);retailTicking=true;}},{passive:true});
    }
    const rack=root.querySelector('[data-fl-rack]');
    if(rack){
      const rackTrack=rack.querySelector('.fl__rack-items');
      const rackItems=Array.from(rack.querySelectorAll('[data-fl-rack-item]'));
      const rackDots=Array.from(rack.querySelectorAll('[data-fl-rack-dot]'));
      const rackTitle=rack.querySelector('[data-fl-rack-title]');
      const rackWord=rack.querySelector('[data-fl-rack-word]');
      const rackCopy=rack.querySelector('[data-fl-rack-copy]');
      const rackCta=rack.querySelector('[data-fl-rack-cta]');
      let rackTicking=false;
      let rackUserActive=false;
      const rackUrl=href=>{
        const url=new URL(href,location.origin);
        if(preview && /^\d+$/.test(preview)) url.searchParams.set('preview_theme_id',preview);
        tracking.forEach((value,key)=>{if(!url.searchParams.has(key)) url.searchParams.set(key,value);});
        return url.href;
      };
      const activateRack=(item,userAction=false)=>{
        if(!item) return;
        const index=Number(item.dataset.index);
        rackItems.forEach(candidate=>{
          const active=candidate===item;
          candidate.classList.toggle('is-active',active);
          candidate.setAttribute('aria-pressed',String(active));
        });
        rackDots.forEach((dot,dotIndex)=>dot.setAttribute('aria-current',String(dotIndex===index)));
        rack.style.setProperty('--rack-accent',item.dataset.accent);
        rackTitle.textContent=item.dataset.title;
        rackWord.textContent=item.dataset.word;
        rackCopy.textContent=item.dataset.copy;
        rackCta.firstChild.textContent=item.dataset.label+' ';
        rackCta.href=rackUrl(item.dataset.href);
        if(userAction) rackUserActive=true;
      };
      rackItems.forEach(item=>{
        item.addEventListener('mouseenter',()=>activateRack(item,true));
        item.addEventListener('focus',()=>activateRack(item,true));
        item.addEventListener('click',()=>activateRack(item,true));
      });
      rackDots.forEach((dot,index)=>dot.addEventListener('click',()=>{
        const item=rackItems[index];
        activateRack(item,true);
        rackTrack.scrollTo({left:item.offsetLeft-(rackTrack.clientWidth-item.clientWidth)/2,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
      }));
      const updateRackFromScroll=()=>{
        if(matchMedia('(max-width: 749px)').matches){
          const center=rackTrack.scrollLeft+rackTrack.clientWidth/2;
          const item=rackItems.reduce((closest,candidate)=>Math.abs(candidate.offsetLeft+candidate.clientWidth/2-center)<Math.abs(closest.offsetLeft+closest.clientWidth/2-center)?candidate:closest,rackItems[0]);
          activateRack(item,rackUserActive);
        }
        rackTicking=false;
      };
      rackTrack.addEventListener('scroll',()=>{if(!rackTicking){requestAnimationFrame(updateRackFromScroll);rackTicking=true;}},{passive:true});
      requestAnimationFrame(()=>{
        const initialRack=rackItems[2];
        activateRack(initialRack,false);
        if(matchMedia('(max-width: 749px)').matches) rackTrack.scrollLeft=initialRack.offsetLeft-(rackTrack.clientWidth-initialRack.clientWidth)/2;
      });
    }
    const garment=params.get('prenda');
    if(['playeras','polos','hoodies'].includes(garment)) root.querySelector('[data-fl-filter="'+garment+'"]')?.click();
    const initial=params.get('enfoque');
    if(initial && ['marca','equipo'].includes(initial)) applyProject(initial);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["formatees-wholesale-request"] && !Shopify.designMode) return;
  try {
    
(() => {
  function initWholesaleForms(root) {
    root.querySelectorAll('.fm-wholesale__form[data-webhook]').forEach((form) => {
      if (form.dataset.bound) return;
      form.dataset.bound = 'true';
      const button = form.querySelector('[type="submit"]');
      const error = form.querySelector('.fm-wholesale__errors[role="alert"]');
      const success = form.querySelector('.fm-wholesale__success');
      const entry = form.querySelector('.fm-wholesale__entry');
      const label = button.textContent;
      const field = (name) => form.elements.namedItem(name);
      field('started_at').value = String(Date.now());
      field('submission_id').value = crypto.randomUUID();
      button.disabled = false;
      let submitting = false;
      let completed = false;
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (submitting || completed || !form.reportValidity()) return;
        submitting = true;
        error.hidden = true;
        button.disabled = true;
        button.textContent = form.dataset.sending;
        form.setAttribute('aria-busy', 'true');
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 25000);
        try {
          const response = await fetch(form.dataset.webhook, {
            method: 'POST',
            body: new URLSearchParams(new FormData(form)),
            credentials: 'omit',
            signal: controller.signal
          });
          const result = await response.json();
          if (!response.ok || result.ok !== true || result.status !== 'received') {
            throw new Error(response.status === 429 ? 'RATE_LIMIT' : 'NOT_CONFIRMED');
          }
          completed = true;
          entry.hidden = true;
          success.hidden = false;
          success.focus();
        } catch (failure) {
          error.textContent = failure.message === 'RATE_LIMIT' ? form.dataset.rateError : form.dataset.error;
          error.hidden = false;
          error.focus();
        } finally {
          clearTimeout(timeout);
          submitting = false;
          form.removeAttribute('aria-busy');
          button.disabled = completed;
          button.textContent = label;
        }
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initWholesaleForms(document), { once: true });
  } else {
    initWholesaleForms(document);
  }
  document.addEventListener('shopify:section:load', (event) => initWholesaleForms(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
